import { useDeviceSetting } from "@-/dev.improve.haniverse.lib.device-settings";
import { useEffect } from "react";
import { CHANGELOG_ENTRIES } from "#changelog-entries";

function latestChangelogEntryDate(): string | null {
  return CHANGELOG_ENTRIES[0]?.date ?? null;
}

/** `YYYY-MM-DD` strings order chronologically under plain string comparison. */
export function hasUnseenChangelogEntries(lastSeenChangelogDate: string | null): boolean {
  const latestDate = latestChangelogEntryDate();
  return (
    latestDate !== null && (lastSeenChangelogDate === null || latestDate > lastSeenChangelogDate)
  );
}

/** Whether this device has not yet opened the Changelog page since its newest entry shipped. */
export function useHasUnseenChangelogEntries(): boolean {
  const [lastSeenChangelogDate] = useDeviceSetting("lastSeenChangelogDate");
  return hasUnseenChangelogEntries(lastSeenChangelogDate);
}

/** Clears the notification while the Changelog page is mounted by recording its newest entry. */
export function useMarkChangelogEntriesSeen(): void {
  const [lastSeenChangelogDate, setLastSeenChangelogDate] =
    useDeviceSetting("lastSeenChangelogDate");

  useEffect(() => {
    const latestDate = latestChangelogEntryDate();
    if (latestDate !== null && hasUnseenChangelogEntries(lastSeenChangelogDate)) {
      setLastSeenChangelogDate(latestDate);
    }
  }, [lastSeenChangelogDate, setLastSeenChangelogDate]);
}
